export const getters = {
  getModal: (state) => state.modal,
  getModalMeta: (state) => state.modalMeta,
  getJustificativaServidor: (state) => state.modalJustificativaServidor,
  getModalAvaliacao: (state) => state.modalAvaliacao,
  getModalAlterarDados: (state) => state.modalAlterarDados,
  getBlockUserModal: (state) => state.modalBlockUser,
  getUnblockUserModal: (state) => state.modalUnblockUser,
  getModalAcceptUsers: (state) => state.modalAcceptUsers,
  getModalDeclineUsers: (state) => state.modalDeclineUsers,
  getModalAtividade: (state) => state.modalAtividade,
  getModalAvaliarAtividade: (state) => state.modalAvaliarAtividade,
  getHealthcare: (state) => state.healthcare,
  getClinic: (state) => state.clinic,
};
